import { useDispatch, useSelector } from 'react-redux'
import MuiDrawer from '@mui/material/Drawer'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import { styled } from '@mui/material/styles'
import { 
  selectIsSidebarCollapsed, 
  selectIsSidebarOpen, 
  setIsSidebarOpen 
} from '@/features/layout/layoutSlice'
import VerticalMenuContent from "./VerticalMenuContent";
import useLayout from '@/features/layout/useLayout'

const VerticalMenu = () => {
  const dispatch = useDispatch();
  const { isMobile } = useLayout();
  const isCollapsed = useSelector(selectIsSidebarCollapsed);
  const isSidebarOpen = useSelector(selectIsSidebarOpen);
  
  return (
    isMobile ? (
      <SwipeableDrawer
        anchor="left"
        open={isSidebarOpen}
        onOpen={() => dispatch(setIsSidebarOpen(true))}
        onClose={() => dispatch(setIsSidebarOpen(false))}
        disableDiscovery
        ModalProps={{ keepMounted: true }}
        slotProps={{
          paper: {
            sx: (theme) => ({
              width: theme.constants.fullDrawerWidth,
              background: theme.palette.sidebar.drawerBg,
              color: theme.palette.text.primary,
              overflow: 'hidden',
              pb: {
                xs: '58px',
                md: 0
              },
            })
          }
        }}
      >
        <VerticalMenuContent />
      </SwipeableDrawer>
    ) : (
      <StyledDesktopDrawer open={isCollapsed} variant="permanent">
        <VerticalMenuContent />
      </StyledDesktopDrawer>
    )
  )
}

const StyledDesktopDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  width: theme.constants.miniDrawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '& .MuiDrawer-paper': {
    width: open 
      ? theme.constants.fullDrawerWidth 
      : theme.constants.miniDrawerWidth,
    borderRight: `1px solid ${theme.palette.sidebar.drawerBorder}`,
    background: theme.palette.sidebar.drawerBg,
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflowX: 'hidden',
    overflowY: 'hidden',
    boxSizing: 'border-box',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 1200,
    boxShadow: open
      ? theme.palette.sidebar.drawerShadow
      : theme.palette.sidebar.drawerShadowMini,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: 500
    })
  }
}))

export default VerticalMenu;